export const MessageCommentAdd = ({
  width = '16',
  height = '16',
  color = '#121212',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_19_10151)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.6 0H14.4C15.2824 0 16 0.7176 16 1.6V11.2C16 12.0824 15.2824 12.8 14.4 12.8H4.2664L0 16V1.6C0 0.7176 0.7176 0 1.6 0ZM3.7336 11.2H14.4V1.6H1.6V12.8L3.7336 11.2ZM8.8 9.6H7.2V7.2H4.8V5.6H7.2V3.2H8.8V5.6H11.2V7.2H8.8V9.6Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_19_10151">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
